import { forwardRef } from "react";
import PropTypes from "prop-types";
import { withClickOutside } from "../../../hoc/withClickOutside";
import SkusFilterDropdownMenu from "./SkusFilterDropdownMenu/SkusFilterDropdownMenu";
import dropdownArrow from "../../../../assets/icons/dropdown_arrow.svg";
import classes from "./SkusFilterDropdown.module.css";

const SkusFilterDropdown = forwardRef((props, ref) => {
  const {
    open,
    setOpen,
    label,
    dropdownText,
    isDisabled,
    menu,
    isMenuLoading,
    menuLoadingError,
    menuItemClassName,
    searchClassName,
    queryStringName,
  } = props;

  const menuToggleHandler = () => {
    if (isDisabled) return;
    setOpen((prevOpen) => !prevOpen);
  };

  const menuClosedHandler = () => {
    setOpen(false);
  };

  return (
    <li className={classes["filter-dropdown"]}>
      <h3 className={classes["filter-dropdown__header"]}>{label}</h3>
      <div ref={ref}>
        <button
          className={classes["filter-dropdown__btn"]}
          onClick={menuToggleHandler}
          disabled={isDisabled}
        >
          <p className={classes["filter-dropdown__text"]} title={dropdownText}>
            {dropdownText}
          </p>
          <img
            src={dropdownArrow}
            alt="dropdown"
            className={classes["filter-dropdown__icon"]}
          />
        </button>
        {open && (
          <SkusFilterDropdownMenu
            menu={menu}
            isLoading={isMenuLoading}
            error={menuLoadingError}
            close={menuClosedHandler}
            queryStringName={queryStringName}
            menuItemClassName={menuItemClassName}
            searchClassName={searchClassName}
          />
        )}
      </div>
    </li>
  );
});

export default withClickOutside(SkusFilterDropdown);

SkusFilterDropdown.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  label: PropTypes.string,
  dropdownText: PropTypes.string,
  isDisabled: PropTypes.bool,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      imageUrl: PropTypes.string,
    })
  ),
  isMenuLoading: PropTypes.bool,
  menuLoadingError: PropTypes.string,
  menuItemClassName: PropTypes.string,
  searchClassName: PropTypes.string,
  queryStringName: PropTypes.string,
};
